import { useCallback } from 'react';
import { useStore } from 'react-redux';
import type { AppState } from '~/reducers';
import { selectAssetById, selectListedAssetById } from '../utils/asset-lookup';

/**
 * Stable callbacks that read one asset from the store at call time, without subscribing the
 * component to list changes.
 */
export const useAssetLookup = () => {
  const store = useStore<AppState>();

  const findAsset = useCallback(
    (iprId: string) => selectAssetById(store.getState(), iprId),
    [store]
  );

  const findListedAsset = useCallback(
    (iprId: string) => selectListedAssetById(store.getState(), iprId),
    [store]
  );

  return { findAsset, findListedAsset };
};
